import Icon from '../components/Icon.vue'

Icon.register({
  marker: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M94 290l75.4-75.4 128 128-75.4 75.4c-44.8 44.8-132.3 86.8-195.3 93.8-15.3 1.7-28.2-11.2-26.5-26.5l0-0.2c7-62.9 49-150.3 93.8-195.1zM485.5 26.5c35.3 35.4 35.3 92.7 0 128l-165.5 165.5-128-128 98.5-98.5-19.6-19.6-87.2 87.1c-6.3 6.3-16.4 6.3-22.6 0l-22.6-22.6c-6.3-6.3-6.3-16.4 0-22.6l104.1-104.1c15.6-15.6 40.9-15.6 56.6 0l36.6 36.5 21.8-21.8c35.4-35.3 92.7-35.3 128 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/marker.js
// module id = 1549
// module chunks = 0